import {Component, Input, OnInit} from '@angular/core';
import TYPES from '..//history.event.types';
import {ContactHistory, ContactHistoryDetails} from '../../contacts-details.model';
import {HistoryService} from '../history.service';
import { getCallMode } from '../../../shared/utils/call-type-mode';
import { getTranslateKeyForContactField } from "../../../shared/utils/get-contact-detail";
import {formatRecordingFileName} from '../../../shared/utils/file-utils';
import {ContactDetailsService} from "../../contact-details.service";

const CALL_EVENT_PROPERTIES = ['clientMsisdn', 'callLength', 'name'];

@Component({
  selector: 'cc-history-body',
  templateUrl: './history-body.component.html',
  styleUrls: ['./history-body.component.scss']
})
export class HistoryBodyComponent implements OnInit {
  @Input() event: ContactHistory;
  public getCallingMode = getCallMode;
  public getContactDetails = getTranslateKeyForContactField;
  public parsedTime: string;
  public changelogData: ContactHistoryDetails[] = [];

  constructor(public historyService: HistoryService,
              public contactDetailsService: ContactDetailsService,) {
  }

  ngOnInit() {
    this.parsedTime = this.parseTime(+this.event.callLength);

    if (this.event.type === 'CONTACT_DETAILS_CHANGE') {
      this.contactDetailsService.getContactDetailsChangelog(this.event.id)
        .subscribe((data: ContactHistoryDetails[]) => {
            this.changelogData = data;
          }
        )
    }
  }

  parseTime(time: number) {
    const minutes = Math.floor(+time / 60);
    const seconds = +time - minutes * 60;
    return minutes > 0 ? `${minutes} min ${seconds} sec` : `${+time} sec`;
  }

  getUserFullName() {
    return `${this.event.name} ${this.event.surname}`;
  }

  getRecordingUrl() {
    return '/calls/' + this.event.callId + '/recording';
  }

  isCallEventProperty(property) {
    return CALL_EVENT_PROPERTIES.includes(property);
  }

  getNewMsisdnTranslation() {
    const systemEventType = TYPES[this.event.type];

    if (systemEventType && systemEventType.newMsisdnTranslation) {
      return systemEventType.newMsisdnTranslation;
    } else {
      return 'RECORDS_LIST.NEW_MSISDN';
    }
  }

  getFileName() {
    return formatRecordingFileName(this.event);
  }

  getIsoCountry(number: string) {
    return this.historyService.getIsoCountry(number);
  }
}
